import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  success: {
    color: '#FFFFFF',
    width: '30px',
    height: '30px',
    margin: '8px',
  },
  badge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    width: 'auto',
    flexDirection: 'row',
    backgroundColor: '#323349',
    height: 'auto',
    minHeight: '70px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '15px',
    color: 'white',
    paddingRight: '8px',
  },
}));
